import { Button } from '@/components/common/Button';
import { FlexRow } from '@/components/common/Flex';
import { ArrowRight } from '@/components/common/icons';
import { RetirementAccountOnboardingStep } from '@common/types';
import { useOpenIraFlowContext } from './OpenIraFlow';

type BreadcrumbType = 'ACCOUNT_TYPE' | 'CONNECT' | 'CONFIRM';

const activeBreadcrumbTypeByStep: Record<
    RetirementAccountOnboardingStep,
    BreadcrumbType | null
> = {
    INTRO: 'ACCOUNT_TYPE',
    BENEFICIARY: 'CONNECT',
    PORTFOLIO: 'CONNECT',
    PLAN: 'CONNECT',
    FUNDING: 'CONNECT',
    TERMS: 'CONNECT',
    REVIEW: 'CONFIRM',
    CELEBRATION: null,
};

const firstStepByBreadcrumbType: Record<
    BreadcrumbType,
    RetirementAccountOnboardingStep
> = {
    ACCOUNT_TYPE: 'INTRO',
    CONNECT: 'PORTFOLIO',
    CONFIRM: 'REVIEW',
};

const OpenIraFlowBreadcrumbs = () => {
    const { iraType } = useOpenIraFlowContext();
    return (
        <FlexRow alignItems="center" gap={4}>
            <Breadcrumb
                type="ACCOUNT_TYPE"
                title={
                    { TRADITIONAL: 'Traditional IRA', ROTH: 'Roth IRA' }[
                        iraType
                    ]
                }
            />
            <ArrowRight color="gray.400" />
            <Breadcrumb type="CONNECT" title="Connect" />
            <ArrowRight color="gray.400" />
            <Breadcrumb type="CONFIRM" title="Confirm" />
        </FlexRow>
    );
};

export default OpenIraFlowBreadcrumbs;

const Breadcrumb = ({
    type,
    title,
}: {
    type: BreadcrumbType;
    title: string;
}) => {
    const { step, setStep } = useOpenIraFlowContext();
    const isActive = activeBreadcrumbTypeByStep[step] === type;

    // TODO: Add logic for which breadcrumb can be clicked,
    // using something like lastCompletedStep.
    // https://linear.app/plenty/issue/PLE-760
    const isClickable = false;

    return (
        <Button
            size="xs"
            fontSize="sm"
            variant="pill"
            colorScheme="transparent"
            color={isActive ? 'text' : 'gray.400'}
            bg={isActive ? 'white' : 'transparent'}
            border="transparent"
            onClick={
                isClickable
                    ? () => setStep(firstStepByBreadcrumbType[type])
                    : undefined
            }
            onClickEvent="Open IRA Flow Breadcrumb Button Clicked"
            onClickEventParams={{ type, title }}
        >
            {title}
        </Button>
    );
};
